import type React from 'react';

function CentraIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="100%" height="100%" viewBox="0 0 35.62 35.62" {...props}>
      <title>CentraIcon</title>

      <g id="Lager_2" data-name="Lager 2">
        <g id="Lager_1-2" data-name="Lager 1">
          <path
            d="M7.45,33.19c2.36,0,4.27-1.93,4.27-4.32s-1.91-4.32-4.27-4.32-4.27,1.93-4.27,4.32,1.91,4.32,4.27,4.32Zm14.12-11.83c2.83,0,5.01-1.91,5.79-3.82l3.69,2.41c-1.89,3.36-5.25,5.73-9.72,5.73-5.95,0-11.37-4.77-11.37-11.75S15.38,2.18,21.33,2.18c4.51,0,7.84,2.41,9.68,5.77l-3.69,2.41c-.74-1.91-2.87-3.82-5.75-3.82-4.51,0-6.98,3.36-6.98,7.43s2.46,7.39,6.98,7.39h0Z"
            fill="currentColor"
          />
          <rect width="35.62" height="35.62" fill="none" />
        </g>
      </g>
    </svg>
  );
}

export default CentraIcon;
